import React from 'react';
import style from './footer.module.css';
import handleScroll from '../scroll/handleScroll';
import { useNavigate } from 'react-router-dom';

function Footer({ setIsScrolling, isOpenMenu, toggleMenu }) {
    const navigate = useNavigate();
    const handleLinkClick = (e, targetId) => {
        handleScroll(e, targetId, navigate, isOpenMenu, toggleMenu, setIsScrolling);
    };
    return (
        <footer className={style['footer']}>
            <div className={style['footer__container']}>
                <div className={style['footer__section']}>
                    <h4 className={style['footer__title']}>Sobre Nosotros</h4>
                    <p className={style['footer__text']}>
                        Somos una empresa dedicada al desarrollo de videojuegos
                        y aplicaciones web, creando experiencias únicas para nuestros clientes.
                    </p>
                </div>
                <div className={style['footer__section']}>
                    <h4 className={style['footer__title']}>Enlaces Rápidos</h4>
                    <ul className={style['footer__list']}>
                        <li><a href='#about' className={style['footer__link']}
                            onClick={(e) => handleLinkClick(e, 'about')}>Sobre Nosotros</a></li>
                        <li><a href='#services' className={style['footer__link']}
                            onClick={(e) => handleLinkClick(e, 'services')}>Servicios</a></li>
                        <li><a href='#contact' className={style['footer__link']}
                            onClick={(e) => handleLinkClick(e, 'contact')}>Contáctanos</a></li>
                    </ul>
                </div>
                <div className={style['footer__section']}>
                    <h4 className={style['footer__title']}>Síguenos</h4>
                    <div className={style['footer__socials']}>
                        <a href='https://youtube.com/@brokendev?si=Uejw7r5yotxMibfc' target='_blank' aria-label='Youtube'
                            rel='noopener noreferrer'
                            className={`bi bi-youtube ${style['footer__icon']}`}></a>
                        <a href='https://www.facebook.com/profile.php?id=61570838014407' target='_blank' aria-label='Facebook'
                            rel='noopener noreferrer'
                            className={`bi bi-facebook ${style['footer__icon']}`}></a>
                        <a href='https://x.com/brokendevco' target='_blank' aria-label='twitter'
                            rel='noopener noreferrer'
                            className={`bi bi-twitter ${style['footer__icon']}`}></a>
                        {/* <a href='https://instagram.com' target='_blank' aria-label='Instagram'
                            rel='noopener noreferrer'
                            className={`bi bi-instagram ${style['footer__icon']}`}></a>
                        <a href='https://tiktok.com' target='_blank' aria-label='Instagram'
                            rel='noopener noreferrer'
                            className={`bi bi-tiktok ${style['footer__icon']}`}></a> */}
                    </div>
                </div>
            </div>
            <div className={style['footer__bottom']}>
                <p>&copy; 2024 BrokenDev. Todos los derechos reservados.</p>
            </div>
        </footer>
    );
}

export default Footer;
